module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "width": "450"
    },
    model: {
      value: (_vm.dialogConfirmaInformacoes),
      callback: function($$v) {
        _vm.dialogConfirmaInformacoes = $$v
      },
      expression: "dialogConfirmaInformacoes"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("Confirma as informações da ação?")]), _vm._v(" "), (_vm.projeto.classificacaoSecundaria.id === 39729 || _vm.projeto.classificacaoSecundaria.id === 44194 || _vm.projeto.classificacaoSecundaria.id === 44195 || _vm.projeto.classificacaoSecundaria.id === 39730) ? _c('div', [_c('v-card-text', {
    staticClass: "title",
    staticStyle: {
      "word-break": "break-word",
      "margin-top": "10px"
    },
    attrs: {
      "align": "justify"
    }
  }, [_vm._v("Para preenchimento\n          do relatório técnico é necessário que todas as informações estejam atualizadas no sistema , incluindo:\n        ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "title",
    staticStyle: {
      "word-break": "break-word",
      "margin-top": "10px"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("- Finalizar a\n          participação dos membros da equipe;\n        ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "title",
    staticStyle: {
      "word-break": "break-word",
      "margin-top": "10px"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("- Preencher a aba\n          Atividades;\n        ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "title",
    staticStyle: {
      "word-break": "break-word",
      "margin-top": "10px"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("- Anexar documentação\n          comprobatória da ação na aba Arquivos.\n        ")])], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.toAtualizar()
      }
    }
  }, [_vm._v("Atualizar as informações da ação")])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.toAdicionarRelatorio()
      }
    }
  }, [_vm._v("As informações já estão atualizadas")])], 1)], 1)], 1), _vm._v(" "), (_vm.administrador === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true || _vm.usuarioPROEX === true) ? _c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "instrucao"
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-text', {
    staticClass: "black--text font-weight-bold"
  }, [_vm._v("\n            Em caso de dúvidas ou sugestões entrar em contato pelo e-mail "), _c('a', {
    attrs: {
      "href": "mailto:suporte.proex@ufes.br"
    }
  }, [_vm._v("suporte.proex@ufes.br")]), _vm._v(". Já em caso de problemas com o sistema\n            entrar em contato pelo "), _c('a', {
    attrs: {
      "href": "https://redmine.ufes.br/projects/suporte-projetos-extensao/issues/new",
      "target": "_blank"
    }
  }, [_vm._v("Sistema de Suporte")]), _vm._v(".\n          ")])], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaRelatorios,
      "search": _vm.search,
      "no-data-text": 'Nenhum relatório encontrado.',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.id",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'RelatorioTecnico',
              params: {
                idProjeto: _vm.idProjeto,
                idRelatorioExtensao: props.item.id
              }
            }
          }
        }, [_vm._v("\n        Relatório " + _vm._s(props.item.ordem) + "\n      ")])]
      }
    }, {
      key: "item.dtInicial",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtInicial)))]
      }
    }, {
      key: "item.dtFinal",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtFinal)))]
      }
    }, {
      key: "item.tipoRelatorioTecnicoItem",
      fn: function(props) {
        return [_vm._v("\n      " + _vm._s(props.item.tipoRelatorioTecnicoItem === 1 ? "Relatório Parcial" :
          props.item.tipoRelatorioTecnicoItem === 2 ? "Relatório Parcial com Renovação" :
          props.item.tipoRelatorioTecnicoItem === 3 ? "Relatório Final" : "Tipo Inválido") + "\n    ")]
      }
    }, {
      key: "item.situacaoRelatorioTecnicoItem",
      fn: function(props) {
        return [_vm._v("\n      " + _vm._s(props.item.situacaoRelatorioTecnicoItem === 1 ? "Em elaboração" :
          props.item.situacaoRelatorioTecnicoItem === 2 ? "Aguardando aprovação" :
          props.item.situacaoRelatorioTecnicoItem === 3 ? "Aprovado" :
          props.item.situacaoRelatorioTecnicoItem === 4 ? "Reprovado" : "Situação inválida") + "\n    ")]
      }
    }, {
      key: "item.dtSubmissaoRelatorio",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtSubmissaoRelatorio)))]
      }
    }, {
      key: "item.dtDecisaoRelatorio",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(_vm.relatorioTecnico.formataDataDecisao(props.item.situacaoRelatorioTecnicoItem,
          props.item.dtAprovacaoRelatorio, props.item.dtReprovacaoRelatorio))))]
      }
    }, {
      key: "item.opcoes",
      fn: function(props) {
        return [(props.item.situacaoRelatorioTecnicoItem === 1 && (_vm.relatorioHabilitadoAcaoRegistroTardio() === false) && (_vm.situacaoAtivo() || _vm.situacaoAguardandoRelatorio()) && (_vm.usuarioCoordenador() || _vm.usuarioAdministrador())) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "open_in_browser",
            "color": "primary",
            "disabled": _vm.situacaoAtivo() === true,
            "tooltip": "Submeter para aprovação",
            "disabled-tooltip": "É possível submeter o relatório para aprovação apenas quando a ação de extensão está na situação Aguardando envio de relatório"
          },
          on: {
            "click": function($event) {
              return _vm.toSubmeter(props.item.id)
            }
          }
        }) : _vm._e(), _vm._v(" "), ((props.item.situacaoRelatorioTecnicoItem === 2 || props.item.situacaoRelatorioTecnicoItem === 3) && _vm.usuarioPermissaoEspelhoRelatorio()) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "picture_as_pdf",
            "color": "primary",
            "tooltip": "Gerar PDF"
          },
          on: {
            "click": function($event) {
              return _vm.toGerarPDF(props.item.id)
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.usuarioPermissaoAprovarRelatorio(props.item.situacaoRelatorioTecnicoItem)) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "done_outline",
            "color": "green",
            "tooltip": "Aprovar"
          },
          on: {
            "click": function($event) {
              return _vm.toAprovar(props.item.id)
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.usuarioPermissaoDevolverReprovarRelatorio(props.item.situacaoRelatorioTecnicoItem)) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "not_interested",
            "color": "red",
            "tooltip": "Devolver"
          },
          on: {
            "click": function($event) {
              return _vm.toDevolver(props.item.id)
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.usuarioPermissaoDevolverReprovarRelatorio(props.item.situacaoRelatorioTecnicoItem)) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "cancel",
            "color": "black",
            "tooltip": "Reprovar"
          },
          on: {
            "click": function($event) {
              return _vm.toReprovar(props.item.id)
            }
          }
        }) : _vm._e()]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n      Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaRelatorios.length) + " relatórios\n    ")]
      }
    }])
  }), _vm._v(" "), _c('c-card-footer', {
    attrs: {
      "projeto": this.projeto,
      "extensao": this.extensao,
      "habilitaBotaoGerarPDFAcao": false
    }
  }, [((_vm.habilitaNovoRelatorio() && (_vm.possivelAdicionar === true)) || (_vm.relatorioHabilitadoAcaoRegistroTardio() && (_vm.possivelAdicionar === true))) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.btnNovoRelatorio
    }
  }, [_vm._v("\n      Novo relatório\n    ")]) : _vm._e(), _vm._v(" "), (_vm.habilitaNovoRelatorio() && _vm.possivelAdicionar === false) ? _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', _vm._g({
          staticStyle: {
            "float": "left"
          }
        }, on), [_c('v-btn', {
          attrs: {
            "disabled": "",
            "color": "primary",
            "text": ""
          },
          on: {
            "click": _vm.btnNovoRelatorio
          }
        }, [_vm._v("Novo relatório")])], 1)]
      }
    }], null, false, 236574399)
  }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.motivo))])]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdc37ad6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/projeto/projeto-relatorios-tabela.vue
// module id = 511
// module chunks = 0